// This component will be used for User Badges and Tags and auto-complete tokens
import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'

const tokenSizes = {
   sm: {
      height: '15px',
      padding: '0px 4px',
      textSize: '0.85'
   },
   md: {
      height: '20px',
      padding: '0px 7px',
      textSize: '1.5'
   },
   lg: {
      height: '25px',
      padding: '0px 10px',
      textSize: '2'
   }
}

const Token = ({ backgroundColor, name, size, textColor }) => (
   <View
      flex="0 0 auto"
      display="inline-flex"
      alignItems="center"
      height={tokenSizes[size].height}
      backgroundColor={backgroundColor}
      borderRadius="3px"
      marginRight="3px"
      padding={tokenSizes[size].padding}>
      <Text
         size={tokenSizes[size].textSize}
         color={textColor}>
         {name}
      </Text>
   </View>
)

Token.propTypes = {
   backgroundColor: PropTypes.string,
   name: PropTypes.string.isRequired,
   size: PropTypes.oneOf(['sm', 'md', 'lg']),
   textColor: PropTypes.string
}

Token.defaultProps = {
   backgroundColor: '#eee',
   size: 'sm',
   textColor: '#555'
}

export default Token
